export default __webpack_public_path__ + "static/media/0092.710614af.jpg";